module.exports = __webpack_public_path__ + "static/media/classes.01e022d2.svg";